/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SiegeLieuSuiviFichierGridDto
 */
export interface SiegeLieuSuiviFichierGridDto {
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviFichierGridDto
     */
    idsiegeLieuSuiviFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviFichierGridDto
     */
    idtypeSuiviFichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SiegeLieuSuiviFichierGridDto
     */
    typeSuiviFichier?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviFichierGridDto
     */
    idfichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SiegeLieuSuiviFichierGridDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviFichierGridDto
     */
    uploadUser?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SiegeLieuSuiviFichierGridDto
     */
    creationUserName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SiegeLieuSuiviFichierGridDto
     */
    uploadDate?: Date | null;
}

/**
 * Check if a given object implements the SiegeLieuSuiviFichierGridDto interface.
 */
export function instanceOfSiegeLieuSuiviFichierGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SiegeLieuSuiviFichierGridDtoFromJSON(json: any): SiegeLieuSuiviFichierGridDto {
    return SiegeLieuSuiviFichierGridDtoFromJSONTyped(json, false);
}

export function SiegeLieuSuiviFichierGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiegeLieuSuiviFichierGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsiegeLieuSuiviFichier': !exists(json, 'idsiegeLieuSuiviFichier') ? undefined : json['idsiegeLieuSuiviFichier'],
        'idtypeSuiviFichier': !exists(json, 'idtypeSuiviFichier') ? undefined : json['idtypeSuiviFichier'],
        'typeSuiviFichier': !exists(json, 'typeSuiviFichier') ? undefined : json['typeSuiviFichier'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'uploadUser': !exists(json, 'uploadUser') ? undefined : json['uploadUser'],
        'creationUserName': !exists(json, 'creationUserName') ? undefined : json['creationUserName'],
        'uploadDate': !exists(json, 'uploadDate') ? undefined : (json['uploadDate'] === null ? null : new Date(json['uploadDate'])),
    };
}

export function SiegeLieuSuiviFichierGridDtoToJSON(value?: SiegeLieuSuiviFichierGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsiegeLieuSuiviFichier': value.idsiegeLieuSuiviFichier,
        'idtypeSuiviFichier': value.idtypeSuiviFichier,
        'typeSuiviFichier': value.typeSuiviFichier,
        'idfichier': value.idfichier,
        'fileName': value.fileName,
        'uploadUser': value.uploadUser,
        'creationUserName': value.creationUserName,
        'uploadDate': value.uploadDate === undefined ? undefined : (value.uploadDate === null ? null : value.uploadDate.toISOString()),
    };
}

